<template>
  <div class="phoneNo-register">
    <h3>个人用户注册</h3>
    <p>请输入手机号、验证码、密码</p>
    <van-form @submit="onSubmit" class="second-phone-form">
      <van-field
        v-model="phoneNo"
        name="手机号"
        placeholder="请输入手机号"
        type="tel"
        maxlength="11"
        ref="phoneNoInput"
        class="userType from-field-phone"
        :rules="[
          { required: true, message: '请输入手机号' },
          { pattern: phoneReg, message: '请输入正确的手机号' },
        ]"
      />
      <van-field
        v-model="verifyCode"
        center
        clearable
        type="number"
        class="userType from-field-phone"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <span
            class="verifycode-text van-hairline--left"
            @click="_sendCode"
            v-if="codeShow"
            >{{ getCodeText }}</span
          >
          <span class="verifycode-text van-hairline--left" v-show="!codeShow"
            >{{ count }} s</span
          >
        </template>
      </van-field>
      <van-field
        v-model="password"
        name="密码"
        placeholder="请输入密码(数字、字母大小写，不少于8位)"
        :type="passwordType"
        class="userType from-field-phone"
        :rules="[
          {
            required: true,
            message: '请输入密码',
          },
          {
            pattern: pwdReg,
            message: '请按规则填写密码(数字、字母大小写，不少于8位)',
          },
        ]"
      >
        <template slot="right-icon">
          <img
            style="width: 0.6rem; height: 0.6rem"
            :src="imgUrl"
            alt=""
            @click="switchPasswordType"
          />
        </template>
      </van-field>
      <div class="submit-item checkBox" style="padding: 0">
        <div>
          <van-checkbox
            v-model="check"
            shape="round"
            icon-size="15px"
            style="margin-top: -1px"
          />
        </div>
        <span style="color: #666666; margin-left: 6px">
          我已阅读并同意《
          <span class="checkbox-text" @click="protocol(1)"
            >自然人实名注册协议</span
          >》和《
          <span class="checkbox-text" @click="protocol(2)"
            >免责声明及用户隐私政策</span
          >》
        </span>
      </div>
      <div class="from-button">
        <van-button
          round
          block
          type="info"
          :disabled="!phoneNo || !verifyCode || !password "
          native-type="submit"
        >
          完成
        </van-button>
      </div>
    </van-form>
    <van-popup v-model="txtShow" round :style="{ height: '85%', width: '82%' }">
      <protocolTxt
        :protocolContent="protocolContent"
        @iKnowBtnClick="iKnowBtnClick"
      ></protocolTxt>
    </van-popup>
  </div>
</template>

<script>
import { naturalReg, sendCode, getItem, login } from "../../api/user";
import { request } from "../../utils/request";
import protocolTxt from "../userRegister2/protocolTxt.vue";
import { mapActions,mapGetters } from "vuex";
import passwordDisplay from '@/assets/icons/pwdhide.png'
import textDisplay from '@/assets/icons/pwdshow.png'

export default {
  data () {
    return {
      pwdReg: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,30}$/,
      phoneReg: /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/,
      phoneNo: '',
      password: '',
      verifyCode: "", // 短信验证码
      getCodeText: "获取验证码",
      count: "",
      timer: null,
      codeShow: true,
      protocolContent: "",
      txtShow: false,
      check: false,
      passwordType: "password",
      imgUrl: passwordDisplay,
    };
  },
  components: {
    protocolTxt
  },
  computed: {
    ...mapGetters({ idCard: 'idcard', userName: 'userName' }),
  },
  methods: {
    ...mapActions({
      setIdcard: "user/setIdcard",
      setUserName: "user/setUserName"
    }),
    onSubmit (values) {
      if (!this.check) {
        this.$toast("请同意遵守相关协议和隐私政策");
      } else {
        naturalReg({
          userName: this.userName,
          userCardnum: this.idCard,
          userPhone: this.phoneNo,
          encrypId: this.password,
          code: this.verifyCode
        })
          .then(res => {
            let { respCode, respMsg, sgasession } = res;
            if (respCode !== "00000000") {
              if (res.error) {
                this.$toast(res.errorMessage);
              } else {
                this.$toast(respMsg);
              }
            } else {
              // 成功
              this.$toast(respMsg);
              // setTimeout(() => {
              //   this.JSBridge.closeNewWindow();
              // }, 1500);
              this.setIdcard(this.idCard); //存身份证号
              this.setUserName(this.userName); //存姓名
              console.log("提交姓名",this.userName)
              this.$router.push("/legalRegisterFinal");
            }
          })
          .then(err => {
            console.log("err", err);
          });
        // setTimeout(() => {
        //   this.regBtnDisable = false;
        // }, 7000);
      }
    },
    switchPasswordType () {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      this.imgUrl = this.passwordType === 'password' ? passwordDisplay : textDisplay;
    },
    protocol (num) {
      // 查看协议
      this.protocolContent = num;
      this.txtShow = true;
    },
    iKnowBtnClick () {
      this.txtShow = false;
    },
    _sendCode () {
      //    let phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!this.phoneNo) {
        return this.$toast("请输入手机号");
      }
      //   if (!this.phoneReg.test(this.phoneNo)) {
      //     return this.$toast("请输入正确的手机号");
      //   }
      const TIME_COUNT = 60;
      // 调用发短信接口
      this.getCodeText = "发送中...";
      sendCode({
        userPhone: this.phoneNo
      })
        .then(res => {
          let { respCode, respMsg, sgasession } = res;
          if (respCode !== "00000000") {
            this.getCodeText = "获取验证码";
            this.$toast(respMsg);
          } else {
            this.$toast("短信发送成功");
            // 成功
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
              this.getCodeText = "获取验证码";
            }
          }
        })
        .then(err => {
          console.log("err", err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@blue: #108ee9;
.phoneNo-register {
  height: 100vh;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
  h3 {
    font-size: 0.8rem;
    color: #333333;
    margin-bottom: 5px;
    margin-top: 30px;    
    font-weight: 550;
  }
  p {
    font-size: 0.4rem;
    color: #999999;
    letter-spacing: 1.5px;
    margin-top: 15px;
  }
  .second-phone-form {
    margin-top: 20px;
  }
  .verifycode-text,
  .userid-select {
    padding-left: 10px;
    width: 150px;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
  .verifycode-text {
    color: @blue;
  }

  .from-field-phone {
    font-size: 0.4rem;
    padding: 15px 10px;
    line-height: 25px;
    box-sizing: border-box;
  }
  .userType {
    font-size: 0.4rem;
    padding-left: 0;
  }
  .van-cell:not(:last-child)::after {
    border: none;
  }
  .van-cell {
    border-bottom: 0.02667rem solid #ebedf0;
  }
  .from-button {
    width: 100%;
    border-radius: 5px;
    button {
      border-radius: 3px;
      margin-top: 20px;
      height: 50px;
    }
  }
  /deep/ .van-button--disabled {
    background-color: #ebebeb;
    border-color: #ebebeb;
    opacity: 1;
  }
}
.submit-item {
  display: flex;
  align-items: center;
}
.checkBox {
  span {
    font-size: 8px;
  }
  margin-top: 18px;
  padding: 0 20px;
  /deep/ .van-checkbox__icon .van-icon {
    border-color: @blue;
    // border-radius: 3px;
  }
  .checkbox-text {
    color: @blue;
  }
}
</style>